import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/triggers/`,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {
  /**
   * @param domainId
   * @return AxiosPromise
   */
  getTemplates(domainId) {
    return conduit.get(`templates/domains/${domainId}/with-attachments`);
  },

  /**
   * @param template
   * @return AxiosPromise
   */
  createTemplate(template) {
    return conduit.post(`templates/domains/${template.domainId}/create`, template);
  },

  /**
   * @param template
   * @return AxiosPromise
   */
  editTemplate(template) {
    return conduit.put(`templates/domains/${template.domainId}/update`, template);
  },

  /**
   * @param domainId
   * @param revision
   * @param triggerTypeId
   * @return AxiosPromise
   */
  getRulesForDomain(domainId, revision, triggerTypeId) {
    if (revision) {
      return conduit.get(`rules/domains/${domainId}/trigger-type/${triggerTypeId}?revision=${revision}`);
    }
    return conduit.get(`rules/domains/${domainId}/trigger-type/${triggerTypeId}`);
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @param templates
   * @return AxiosPromise
   */
  createRevision(domainId, triggerTypeId, templates) {
    return conduit.post(`rules/domains/${domainId}/trigger-type/${triggerTypeId}/create`, { templates });
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @return AxiosPromise
   */
  getRevisions(domainId, triggerTypeId) {
    return conduit.get(`rules/domains/${domainId}/trigger-type/${triggerTypeId}/revisions`);
  },

  /**
   * @return AxiosPromise
   */
  getPreviewData() {
    return conduit.get('lists/preview');
  },

  /**
   * @return AxiosPromise
   */
  getOverview() {
    return conduit.get('lists/overview');
  },

  /**
   * @param list
   * @return AxiosPromise
   */
  getList(list) {
    return conduit.get(`lists/${list}`);
  },

  /**
   * @param bookingId
   * @return AxiosPromise
   */
  getPaymentMessages(bookingId) {
    return conduit.get(`lists/booking/${bookingId}/payment-messages`);
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @return AxiosPromise
   */
  getSettings(domainId, triggerTypeId) {
    return conduit.get(`rules/domains/${domainId}/trigger-type/${triggerTypeId}/settings`);
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @param setting
   * @return AxiosPromise
   */
  createSetting(domainId, triggerTypeId, setting) {
    return conduit.post(`rules/domains/${domainId}/trigger-type/${triggerTypeId}/settings/create`, setting);
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @param setting
   * @return AxiosPromise
   */
  updateSetting(domainId, triggerTypeId, setting) {
    return conduit.put(
      `rules/domains/${domainId}/trigger-type/${triggerTypeId}/settings/${setting.id}/update`,
      setting,
    );
  },

  /**
   * @param domainId
   * @param triggerTypeId
   * @param setting
   * @return AxiosPromise
   */
  deleteSetting(domainId, triggerTypeId, setting) {
    return conduit.put(
      `rules/domains/${domainId}/trigger-type/${triggerTypeId}/settings/${setting.id}/delete`,
      setting);
  },

  /**
   * @param domainId
   * @param setting
   * @return AxiosPromise
   */
  activateSetting(domainId, setting) {
    return conduit.put(`rules/domains/${domainId}/settings/${setting.id}/activate`, setting);
  },

  /**
   * @param domainId
   * @param settingId
   * @return AxiosPromise
   */
  getLogs(domainId, settingId) {
    return conduit.get(`rules/domains/${domainId}/settings/${settingId}/logs`);
  },

  /**
   * @param domainId
   * @param settingId
   * @return AxiosPromise
   */
  getTriggerTypes() {
    return conduit.get('types');
  },
};



// WEBPACK FOOTER //
// ./src/services/trigger-service.js